import React from 'react'
import './headerStyle.scss'
import Home from '../resources/images/home.png'

const Header = () => (
  <div style={{display: 'block', width: '100%', backgroundColor: '#213b4a'}}>
    <nav>
      <ul id="menu">
        <li className="home"><a href="/home"><img src={Home} style={{width: 36, height: 36, verticalAlign: 'middle', marginRight: 10}}/>Corpus Linguistics</a></li>
        <li className="title">Asian Corpus of English</li>
        <li><a href="/ace/About.html">About</a></li>
        <li><a href="/ace/Objectives.html">Objectives</a></li>
        <li><a href="/ace/Corpus.html">Corpus Info</a></li>
        <li><a href="/ace/ContactUs.html">Contact US</a></li>
        <li><a href="/ace/view/#/browse">Browse Files</a></li>
        <li><a href="/ace_search/">Search</a></li>
        <li><a href="/ace_tagged/">Search Tagged Corpus</a></li>
        <li className="end"></li>
      </ul>
    </nav>
    <div style={{clear: 'both'}}></div>
  </div>
)

export default Header


// WEBPACK FOOTER //
// ./src/components/Header.js